import { Grid } from "@material-ui/core";
import ExportButton from "components/ExportButton/ExportButton";
import { useGetClientsQuery } from "features/clients/clientSlice";
import { useGetLotsQuery } from "features/lots/lotSlice";
import { selectTenantName } from "features/user/userSlice";
import { useGetVehiclesQuery } from "features/vehicles/vehicleSlice";
import { IconDownload } from 'icons';
import { groupBy } from "lodash";
import { useSelector } from "react-redux";
import { totalAssetsStyle } from "../../DispatchDashboard/TotalAssets/style";

const TotalAssetsDomicile = ({ outOfPmfResponsibilityId }) => {
    const classes = totalAssetsStyle();

    const tenantName = useSelector(selectTenantName);

    let { data: clients, error: clientError, isLoading: isLoadingClients } = useGetClientsQuery(null);
    let { data: lots, error: lotsError, isLoading: isLoadingLots } = useGetLotsQuery();
    let { data: vehiclesData, error: vehicleError, isFetching: isFetchingVehicles, refetch: refetchVehicles } = useGetVehiclesQuery({ includeHistory: true });
    const clientAccounts = clients?.flatMap(c => c.clientAccounts);

    const tenantLots = lots?.filter(l => l.ownedByTenant)?.map(l => l.id);

    const { filters } = useSelector(state => state.dashboardState);

    let filteredData = vehiclesData?.filter(v =>
        (filters.isDefaultAccount ? (!filters.clientId || filters.clientId == v.clientId)
            : (!filters.clientAccountId || filters.clientAccountId == v.clientAccountId)) &&
        v.vehicleStatusId != outOfPmfResponsibilityId &&
        v.domicileLot && tenantLots?.includes(v.domicileLot)
    );

    const groupedToClient = groupBy(filteredData, 'clientAccountId');
    const dataForExport = Object.keys(groupedToClient).map(key => ({ clientAccountId: key, count: groupedToClient[key]?.length }))

    const mapExportData = row => {
        return ({
            client: clientAccounts?.find(c => c.id == row.clientAccountId)?.name,
            count: row.count
        })
    };

    return (
        <>
            <Grid className={classes.wrapper} container direction="column">
                <div className={classes.exportBtn}>
                    <ExportButton btnStyle='text' label="" icon={<IconDownload />} fileLabel="Export" data={dataForExport} mapExportData={mapExportData} />
                </div>
                <Grid item className={`${classes.count} ${classes.countBlue}`}>{filteredData?.length || 0}</Grid>
                <Grid item><h3 className={classes.text}>{`Assets Domiciled on ${tenantName} lots`}</h3></Grid>
            </Grid>
        </>
    )
}

export default TotalAssetsDomicile;